export const sendEvent = (eventData) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'ga-send',
      ...eventData,
    });
  }
};
